import { render, staticRenderFns } from "./sozlesme.vue?vue&type=template&id=0029cbd3"
import script from "./sozlesme.vue?vue&type=script&lang=js"
export * from "./sozlesme.vue?vue&type=script&lang=js"
import style0 from "./sozlesme.vue?vue&type=style&index=0&id=0029cbd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports